import 'slick-carousel';

$('#product .product__slider').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	infinite: false,
	asNavFor: '#product .product__thumbs'
});

$('#product .product__thumbs').slick({
	slidesToShow: 4,
	slidesToScroll: 4,
	dots: false,
	arrows: false,
	infinite: false,
	asNavFor: '#product .product__slider',
	focusOnSelect: true
});
